module.exports = __webpack_public_path__ + "img/5.SJ.35aa4118.jpg";